export default __webpack_public_path__ + "static/media/camisa.db19ebd3.jpg";